import { StateStream } from '@cgs/wge';

export const HELP_POPUP_COMPONENT_TOKEN = Symbol('HELP_POPUP_COMPONENT_TOKEN');

export abstract class HelpPopupComponent {
  public readonly isShown: StateStream<boolean> = new StateStream(false);
  public abstract show(): void;
  public abstract hide(): void;
}
